module.exports = __webpack_public_path__ + "img/PDAC1_Myofibroblasts.0341a0cf.png";